// extracted by mini-css-extract-plugin
export var tosLink = "_bu-0";